module.exports = __webpack_public_path__ + "static/media/icn-arrow-back.e40413c1.svg";